import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function Header() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    checkUser();
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const checkUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setUser(user);
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/1c23ac013da7acba6bbfb5cc15dbe4ac.png" 
              alt="星允信息" 
              className="h-12"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <nav className="flex items-center space-x-8">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                首页
              </Link>
              <Link
                to="/products"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/products') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                产品
              </Link>
              <Link
                to="/services"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/services') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                服务
              </Link>
              <Link
                to="/cases"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/cases') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                案例
              </Link>
              <Link
                to="/resources"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/resources') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                资源
              </Link>
              <Link
                to="/about"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/about') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                关于
              </Link>
            </nav>

            <div className="flex items-center space-x-4">
              <Link
                to="/search"
                className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors"
              >
                <i className="ri-search-line text-xl"></i>
              </Link>
              {user ? (
                <Link
                  to="/member-center"
                  className="flex items-center px-4 py-2 bg-gradient-to-r from-teal-600 to-cyan-600 text-white rounded-lg hover:from-teal-700 hover:to-cyan-700 transition-all whitespace-nowrap"
                >
                  <i className="ri-user-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                  会员中心
                </Link>
              ) : (
                <Link
                  to="/login"
                  className="px-6 py-2 bg-gradient-to-r from-teal-600 to-cyan-600 text-white rounded-lg hover:from-teal-700 hover:to-cyan-700 transition-all whitespace-nowrap"
                >
                  登录 / 注册
                </Link>
              )}
            </div>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-2">
            <Link
              to="/"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'bg-teal-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              首页
            </Link>
            <Link
              to="/products"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/products') ? 'bg-teal-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              产品
            </Link>
            <Link
              to="/services"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/services') ? 'bg-teal-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              服务
            </Link>
            <Link
              to="/cases"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/cases') ? 'bg-teal-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              案例
            </Link>
            <Link
              to="/resources"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/resources') ? 'bg-teal-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              资源
            </Link>
            <Link
              to="/about"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about') ? 'bg-teal-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              关于
            </Link>
            <Link
              to="/search"
              className="block px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors whitespace-nowrap"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="ri-search-line mr-2"></i>
              搜索
            </Link>
            {user ? (
              <Link
                to="/member-center"
                className="block px-4 py-2 bg-gradient-to-r from-teal-600 to-cyan-600 text-white rounded-lg text-center text-sm font-medium whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                会员中心
              </Link>
            ) : (
              <Link
                to="/login"
                className="block px-4 py-2 bg-gradient-to-r from-teal-600 to-cyan-600 text-white rounded-lg text-center text-sm font-medium whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                登录 / 注册
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
